import { REACT_QUERY_KEYS } from 'common'
import { setPurposesBR } from 'common/services/br/br-purposes'
import { ChangeFinalidade } from 'common/types'
import { useAppContext } from 'contexts/app-context/hooks'
import { entityPayloadMap } from 'contexts/app-context/types/app-context/components/utils'

import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'

const successHandler = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: [REACT_QUERY_KEYS.PURPOSES] })
}

export const useChangePreference = ({ onSuccess }: { onSuccess: () => void }) => {
  const { privacyCenterContent, userAccountType, userCountry, userSelectedEntity } = useAppContext()

  const productMenu =
    privacyCenterContent?.components.manageNotifications?.content.productsSection.productMenu

  const updatePreferencesEndpoint = privacyCenterContent?.endpoints.preferences?.updatePreferences

  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({ metadados, productID }: ChangeFinalidade) => {
      const customHeaders = userCountry &&
        userSelectedEntity && {
          'x-inter-user-org': userCountry,
          'x-inter-account-org': entityPayloadMap[userSelectedEntity],
        }

      if (!userAccountType || !updatePreferencesEndpoint) throw new Error('User type not found')

      if (userAccountType === 'PJ' && productMenu) {
        const productList = productMenu[productID as keyof typeof productMenu]?.subProducts

        if (productList) {
          return Promise.all(
            productList.map((product) =>
              setPurposesBR(
                metadados,
                userAccountType,
                product,
                updatePreferencesEndpoint,
                customHeaders,
              ),
            ),
          )
        }
      }

      return setPurposesBR(metadados, userAccountType, productID, updatePreferencesEndpoint)
    },
    onSuccess: () => {
      onSuccess && onSuccess()
      successHandler(queryClient)
    },
    onSettled: () => {
      queryClient.refetchQueries({ queryKey: [REACT_QUERY_KEYS.PURPOSES] })
    },
  })

  return {
    ...mutation,
  }
}
